import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Sanitizer({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sanitizer</title>
      <rect
        x="7"
        y="10"
        width="10"
        height="10"
        rx="2"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.25C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75L10 14.25ZM14 15.75C14.4142 15.75 14.75 15.4142 14.75 15C14.75 14.5858 14.4142 14.25 14 14.25V15.75ZM12.75 13C12.75 12.5858 12.4142 12.25 12 12.25C11.5858 12.25 11.25 12.5858 11.25 13H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM10 15.75L12 15.75V14.25L10 14.25L10 15.75ZM12 15.75L14 15.75V14.25L12 14.25V15.75ZM11.25 13V15H12.75V13H11.25ZM11.25 15L11.25 17H12.75L12.75 15H11.25Z"
        fill={color ?? 'currentColor'}
      />
      <rect
        x="10"
        y="7"
        width="4"
        height="3"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7V4"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.25C9.58579 3.25 9.25 3.58579 9.25 4C9.25 4.41421 9.58579 4.75 10 4.75V3.25ZM16.4697 6.53033C16.7626 6.82322 17.2374 6.82322 17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L16.4697 6.53033ZM10 4.75H14.1716V3.25H10V4.75ZM15.0555 5.11612L16.4697 6.53033L17.5303 5.46967L16.1161 4.05546L15.0555 5.11612ZM14.1716 4.75C14.5031 4.75 14.821 4.8817 15.0555 5.11612L16.1161 4.05546C15.6004 3.53973 14.9009 3.25 14.1716 3.25V4.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
